import { invariant } from "./invariant.js";

const funcRegex =
	/^function(?:\s+([a-zA-Z$_][a-zA-Z0-9$_]*))?\s*\(((?:(?:\s*[a-zA-Z$_][a-zA-Z0-9$_]*)(?:\s*,\s*[a-zA-Z$_][a-zA-Z0-9$_]*)*)?)\s*\)\s*\{((?:.|\n|\r)*)\}$/;

export function parseFunc(func: Function) {
	var match = func.toString().match(funcRegex);
	invariant(match, "Unable to parse function!");
	return { name: match[1], args: match[2].split(","), body: match[3] };
}
